var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2524 12.9865C11.3059 12.9865 12.1634 13.8379 12.1634 14.8844V17.5759C12.1634 17.8008 12.3436 17.981 12.5746 17.9863H14.2424C15.5566 17.9863 16.625 16.931 16.625 15.6343V8.00078C16.6189 7.55453 16.4062 7.13453 16.0414 6.85541L10.2725 2.25466C9.49813 1.64128 8.41488 1.64128 7.63788 2.25641L1.90838 6.85366C1.5295 7.14153 1.31687 7.56153 1.3125 8.01566V15.6343C1.3125 16.931 2.38087 17.9863 3.69512 17.9863H5.37862C5.61575 17.9863 5.80825 17.7982 5.80825 17.5672C5.80825 17.5164 5.81437 17.4657 5.82487 17.4175V14.8844C5.82487 13.844 6.67712 12.9935 7.72275 12.9865H10.2524ZM14.2424 19.2988H12.5589C11.5946 19.276 10.8509 18.5192 10.8509 17.5759V14.8844C10.8509 14.5615 10.5822 14.299 10.2524 14.299H7.72713C7.40425 14.3008 7.13738 14.5642 7.13738 14.8844V17.5672C7.13738 17.6328 7.12863 17.6958 7.11025 17.7553C7.01575 18.6215 6.2755 19.2988 5.37862 19.2988H3.69512C1.65725 19.2988 0 17.6547 0 15.6343V8.00953C0.00875 7.13978 0.4095 6.34353 1.10163 5.81941L6.81975 1.23003C8.07887 0.232533 9.83325 0.232533 11.0898 1.22828L16.849 5.82203C17.5254 6.33741 17.9261 7.13191 17.9375 7.99116V15.6343C17.9375 17.6547 16.2803 19.2988 14.2424 19.2988Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.02c4f381c8d023031d65c09ced3a73aa.svg";
export { ForwardRef as ReactComponent };